import React, { useState, useEffect } from 'react';
import { Menu, Sun, Moon } from 'lucide-react';
import MiniGame from './MiniGame';
import { useTheme } from '../ThemeContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const Header = ({ setSidebarOpen, selectedTable }) => {
  const [dbInfo, setDbInfo] = useState({ database: '', server: '' });
  const [isConnected, setIsConnected] = useState(false);
  const { isDark, toggleTheme } = useTheme();

  useEffect(() => {
    // Fetch database info and check connection
    fetch(`${API_URL}/api/info`)
      .then(res => res.json())
      .then(data => {
        if (data.database) {
          setDbInfo(data.database);
          setIsConnected(true);
        }
      })
      .catch(err => {
        console.error('Failed to load database info:', err);
        setIsConnected(false);
      });
  }, []);

  return (
    <header className="bg-white dark:bg-marble-800 shadow-xl border-b-2 border-primary-600/50 transition-colors duration-300">
      <div className="flex items-center justify-between px-6 py-5">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-primary-300 hover:text-primary-100 lg:hidden transition-colors"
          >
            <Menu className="h-6 w-6" />
          </button>
          
          <div className="flex items-center space-x-4">
            <img 
              src={isDark ? "/politheon-logo-white.png" : "/politheon-logo-darkblue.png"}
              alt="Politheon" 
              className="h-12 w-auto transition-transform duration-200 hover:scale-105"
            />
            <div className="border-l-2 border-primary-600/50 pl-4">
              <h1 className="text-2xl font-bold text-gray-800 dark:text-primary-200 tracking-wide transition-colors">
                Schema Dashboard
              </h1>
              <p className="text-xs text-gray-600 dark:text-marble-500 font-light transition-colors">
                Database Schema Monitoring
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex items-center space-x-6">
          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg bg-marble-700/50 hover:bg-marble-600 dark:bg-marble-700/50 dark:hover:bg-marble-600 transition-colors"
            title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {isDark ? (
              <Sun className="h-5 w-5 text-primary-400" />
            ) : (
              <Moon className="h-5 w-5 text-primary-600" />
            )}
          </button>

          {/* Mini Game Easter Egg */}
          <div className="hidden lg:block">
            <MiniGame />
          </div>
          
          <div className="hidden md:block text-right">
            <div className="flex flex-col items-end space-y-1">
              <div className="flex items-center space-x-2 text-sm">
                <div 
                  className={`w-2 h-2 rounded-full ${
                    isConnected 
                      ? 'bg-green-500 animate-pulse' 
                      : 'bg-red-500'
                  }`}
                  title={isConnected ? 'Connected to Azure SQL' : 'Disconnected'}
                ></div>
                <span className={isConnected ? 'text-primary-300' : 'text-red-400'}>
                  {dbInfo.database || (isConnected ? 'Azure SQL' : 'Disconnected')}
                </span>
              </div>
              {dbInfo.server && (
                <p className="text-xs text-marble-500">{dbInfo.server}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
